import React__default from 'react';
import { OverlayArrow, Tooltip as Tooltip$1, Popover, Dialog } from 'react-aria-components';
import './Tooltip.scss';

const tooltipArrow = (React__default.createElement(OverlayArrow, { className: 'tooltip-arrow--rev' },
    React__default.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '10', height: '6', viewBox: '0 0 10 6', fill: 'none' },
        React__default.createElement("path", { d: 'M4.29308 4.79289L0.000183165 0.5L10.0002 0.5L5.70729 4.79289C5.31677 5.18342 4.6836 5.18342 4.29308 4.79289Z', fill: 'black' }))));
const tooltipDefaultProps = {
    'data-rev-component': 'tooltip',
    offset: 8,
    placement: 'top',
    arrowBoundaryOffset: 5,
};
const Tooltip = ({ children, ...props }) => (React__default.createElement(Tooltip$1, { ...tooltipDefaultProps, ...props },
    tooltipArrow,
    children));
const TooltipPopover = ({ children, ...props }) => (React__default.createElement(Popover, { ...tooltipDefaultProps, ...props },
    tooltipArrow,
    React__default.createElement(Dialog, null, children)));

export { Tooltip, TooltipPopover };
//# sourceMappingURL=Tooltip.js.map
